<template>
<div style="display: inherit">
  <router-link :to="{ name: 'new' }" class="navbar-item">
    <b-icon class="is-hidden-desktop menu-icon" icon="plus"/>
    {{$t('new')}}
  </router-link>
  <router-link :to="{ name: 'shoppingList', params: { id: defaultShoppingListId } }" class="navbar-item">
    <b-icon class="is-hidden-desktop menu-icon" icon="shopping-cart"/>
    {{$t('shoppingList')}}
  </router-link>
</div>
</template>

<i18n src="@/i18n/global.i18n.json"></i18n>

<script>
import i18nMixin from '@/mixins/i18n';
import { mapGetters } from 'vuex';

export default {
  name: 'browseAppToolbar',
  mixins: [i18nMixin],
  computed: {
    ...mapGetters('shoppingList', ['defaultShoppingListId']),
  },
};

</script>




// WEBPACK FOOTER //
// src/components/browse/BrowseAppToolbar.vue